// src/WOQuickModal.js
import { useEffect, useState } from "react";
import WOHistoryPanel from "./WOHistoryPanel";

export default function WOQuickModal({
  open,
  onClose,
  site,
  woSummary,
  onOpenDetails, // ✅ callback from WOList
}) {
  // mode: chooser | history
  const [mode, setMode] = useState("chooser");

  useEffect(() => {
    if (!open) return;
    setMode("chooser");
  }, [open]);

  if (!open) return null;

  const woNum = woSummary?.wo_number || "";
  const desc = woSummary?.description || "";

  return (
    <Modal title={`Work Order — ${woNum || ""}`} onClose={onClose}>
      {/* HEADER */}
      <div className="mb-3">
        <div className="font-mono font-semibold">{woNum || "(no wo_number)"}</div>
        <div className="text-sm text-gray-700">{desc}</div>
        <div className="text-xs text-gray-500 mt-1">Site: {site || "(missing site)"}</div>
      </div>

      {/* CHOOSER */}
      {mode === "chooser" && (
        <div className="flex flex-wrap gap-2">
          <button
            className="px-4 py-2 rounded bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-50"
            type="button"
            disabled={!woNum || !site}
            onClick={() => {
              // ✅ Delegate to parent (WOList) which opens WODetailsPanel
              onOpenDetails?.(woNum);
              onClose?.();
            }}
          >
            📝 WO Details
          </button>

          <button
            className="px-4 py-2 rounded bg-purple-600 text-white hover:bg-purple-700 disabled:opacity-50"
            type="button"
            disabled={!woNum || !site}
            onClick={() => setMode("history")}
          >
            📜 WO History
          </button>

          <button
            className="ml-auto px-4 py-2 rounded bg-gray-200 hover:bg-gray-300"
            type="button"
            onClick={onClose}
          >
            Close
          </button>
        </div>
      )}

      {/* HISTORY */}
      {mode === "history" && (
        <>
          <div className="flex items-center gap-2 mb-3">
            <button
              className="px-3 py-2 rounded bg-gray-200 hover:bg-gray-300"
              type="button"
              onClick={() => setMode("chooser")}
            >
              ◀ Back
            </button>
          </div>

          {/* ✅ This now always has the correct site + woNumber */}
          <WOHistoryPanel site={site} woNumber={woNum} />
        </>
      )}
    </Modal>
  );
}

function Modal({ title, onClose, children }) {
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-[9999]">
      <div className="bg-white rounded-xl w-[min(1000px,95vw)] max-h-[90vh] overflow-hidden shadow-lg">
        <div className="flex items-center justify-between px-4 py-3 border-b">
          <div className="font-semibold">{title}</div>
          <button className="px-3 py-1 rounded bg-gray-200" onClick={onClose} type="button">
            Close
          </button>
        </div>
        <div className="p-4 overflow-auto max-h-[80vh]">{children}</div>
      </div>
    </div>
  );
}
